const accessTokenKey = "nfn-access-token";

const setAccessTokenLocalStorage = (token: string | null) => {
  if (!token) return
  localStorage.setItem(accessTokenKey, token);
}
export default setAccessTokenLocalStorage;